import { useEffect } from "react";
import { useAuth } from "@/context/AuthContext";
import { loadGlobalAds, unloadGlobalAds } from "@/ads/adsterra";
import { isAgeVerified } from "@/components/AgeGate";

// Loads Popunder + Social Bar once for logged-in, age-verified free users.
export default function AdsterraGlobal() {
  const { user } = useAuth();
  useEffect(() => {
    if (user && user.tier !== "premium" && user.role !== "admin" && isAgeVerified()) loadGlobalAds();
    else unloadGlobalAds();
  }, [user]);
  return null;
}
